import { Table } from "@/features/Table";
import { useBulkDeleteControls } from "@/features/Edit/useBulkDeleteControls";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type D1Transaction, porfolios_columns } from "./columns";
import {
  type FilterD1TransactionsSchema,
  FilterD1Transactions,
} from "./filter";

export const D1TransactionsTable = () => {
  const { selectionActions, modal } = useBulkDeleteControls<D1Transaction>({
    client: Clients.D1,
    table_name: Tables.D1_TRANSACTIONS,
    resourceLabel: "Transactions",
  });

  return (
    <>
      <Table<D1Transaction, FilterD1TransactionsSchema>
        label="Transactions"
        client={Clients.D1}
        table_name={Tables.D1_TRANSACTIONS}
        columns={porfolios_columns}
        filter={<FilterD1Transactions />}
        actions={[
          {
            label: "actions.new",
            route: `${Clients.D1}/${Tables.D1_TRANSACTIONS}/new`,
          },
        ]}
        enableRowSelection
        selectionActions={selectionActions}
      />
      {modal}
    </>
  );
};
